import React from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery, Typography } from '@material-ui/core';
import { useTranslate, MenuItemLink, getResources } from 'react-admin';
import MenuItem from '@material-ui/core/MenuItem';
import DefaultIcon from '@material-ui/icons/ViewList';
//import HelpIcon from '@material-ui/icons/HelpOutline';
import DashboardIcon from '@material-ui/icons/HomeOutlined';
import { makeStyles } from '@material-ui/core/styles';
import logo from 'theme/MyLogo';
import { secondaryColour, lightTextColour } from 'theme/MyTheme';
import EmailIcon from '@material-ui/icons/Email';
import FeedbackIcon from '@material-ui/icons/Feedback';
import { buildDate } from 'lib/buildDate';

export const useStyles = makeStyles({
  logoWrap: {
    display: 'flex',
    alignItems: 'center',
    background: secondaryColour,
    color: lightTextColour,
    height: 60,
  },
  logo: {
    maxHeight: '40px',
    background: secondaryColour,
  },
  menuTitle: {
    paddingLeft: 20,
  },
});

export const MyMenu = ({ onMenuClick = () => {}, logout }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const open = useSelector((state) => state.admin.ui.sidebarOpen);
  const resources = useSelector(getResources);
  return (
    <div>
      {isXSmall && (
        <div className={classes.logoWrap}>
          <img className={classes.logo} src={logo} />
          <Typography className={classes.menuTitle}>
            {translate('ra.menu.title', { _: 'Menu' })}
          </Typography>
        </div>
      )}
      <MenuItemLink
        to="/"
        primaryText={translate('ra.menu.dashboard', { _: 'Dashboard' })}
        leftIcon={<DashboardIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
      {resources.map((resource) =>
        resource.options && resource.options.label ? (
          <MenuItemLink
            key={resource.name}
            to={`/${resource.name}`}
            primaryText={
              (resource.options && resource.options.label) || resource.name
            }
            leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
            onClick={onMenuClick}
            sidebarIsOpen={open}
          />
        ) : null
      )}

      <MenuItemLink
        to="/feedback"
        primaryText={translate('ra.menu.feedback', { _: 'Feedback' })}
        leftIcon={<FeedbackIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />

      {/*
      <MenuItemLink
        to="/help"
        primaryText="Help"
        leftIcon={<HelpIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
      */}

      {/* 
      <MenuItemLink
        to="/faqs"
        primaryText="FAQs"
        leftIcon={<HelpIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
      */}

      <MenuItemLink
        to="/contact"
        primaryText="Contact"
        leftIcon={<EmailIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
      {isXSmall && logout}

      <MenuItem>
        <Typography style={{ fontSize: 8 }}>
          Build date:
          <br />
          {buildDate}
        </Typography>
      </MenuItem>
    </div>
  );
};
